export const bonus_round_page = (t) => ({
	BONUS_WIN_TEXT: {
		value: t('bonus.total_win'),
		config: {
			fill: '#CFDBB5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 25
		}
	},
	BONUS_WIN_VALUE: {
		value: '$0.00',
		config: {
			fill: ['#F8EFD7', '#F8EFD7'],
			fontFamily: 'Poppins SemiBold',
			fontSize: 42,
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BONUS_HEART_TEXT: {
		value: '+10',
		config: {
			fontFamily: 'Japanese',
			fontSize: 40,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BONUS_HEART_SUBTEXT: {
		value: 'SPIN',
		config: {
			fontFamily: 'Japanese',
			fontSize: 20,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BONUS_STAR_TEXT: {
		value: '10X',
		config: {
			fontFamily: 'Japanese',
			fontSize: 40,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BONUS_STAR_SUBTEXT: {
		value: 'MULT',
		config: {
			fontFamily: 'Japanese',
			fontSize: 24,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	}
});
